import { Branded } from '@library/type-utils'
import { composeFetch, composeParser } from '@library/http'
import { parseGoustoBasicResponse } from '@library/http/parsers'
import { addPath, auth, composeRequest, setServiceUrl, setQueryParam } from '@library/http/requests'

export type UserID = Branded<string, 'UserId'>

type CardDetails = {
  holder: string,
  number: string,
  type: string,
  cardToken: string,
  paymentProvider: string,
  expiryMonth: number,
  expiryYear: number,
}

type PayPalDetails = {
  cardToken: string,
  paymentProvider: 'paypal'
}

type ApplePayDetails =  {
  cardToken: string,
  paymentProvider: 'applepay'
}

type PaymentMethod = {
  method: 'paypal' | 'applepay',
  name: string,
  isDefault: boolean,
  details: PayPalDetails | ApplePayDetails ,
}

export type CardPaymentMethod = {
  method: 'card',
  name: string,
  isDefault: boolean,
  details: CardDetails,
}

type PaymentMethodData = {
  status: string,
  data: {
    type: 'payment-method',
    attributes: CardPaymentMethod | PaymentMethod,
  },
}

const paymentRequest = (userId: UserID) => composeRequest(
  setServiceUrl('paymentmethodquery'),
  addPath('payment-methods'),
  setQueryParam('userId', userId),
  auth
)

export const fetchPaymentDetails = (userId: UserID) => composeFetch(
  paymentRequest(userId),
  composeParser(
    parseGoustoBasicResponse,
    (basicResponse) => basicResponse as PaymentMethodData,
    (response) => response.data.attributes,
  )
)()
